import _ from 'lodash';
import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import {Modal} from 'react-bootstrap';
import CommonActions from '../../../actions/CommonActions';


const Dialog = (props) => {
  const disablescrollbar = _.get(props, 'disablescrollbar', 'false');

  useEffect(() => {
    if (props.show && disablescrollbar === 'true') {
      CommonActions.inactiveScroll(true);
    }
    return () => {
      if (disablescrollbar === 'true') {
        CommonActions.inactiveScroll(false);
      }
    }
  }, []);

  const className = _.get(props, 'className', '');
  const openClassCSS = props.show ? `modal-open ${className}` : '';

  return (
    <Modal className={openClassCSS} {...props}>
      {props.children}
    </Modal>
  );
};

Dialog.Header = Modal.Header;
Dialog.Title = Modal.Title;
Dialog.Footer = Modal.Footer;
Dialog.Body = Modal.Body;

Dialog.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
  ]),
  show: PropTypes.bool,
  className: PropTypes.string,
  disablescrollbar: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
};

Dialog.defaultProps = {
  disablescrollbar: 'false'
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/Wrapper/Modal.js